import { Observable, Subject } from 'rxjs';
export class ApiError {
    constructor(public action: Subject<any>) { }
    public http(err: any): any {
        let error: { message: string, action?: string } = { message: "Something went wrong" };
        let status: number = err.status;
        if (status || status === 0) {
            status = (status === 0) ? this.getHiddenStatus(err.message) : err.status;
            switch (status) {
                case 0:
                    // console.log('here.in')
                    error.action = "ignore";
                    error.message = 'Unknow Error: Connection issue of inavlid API path';
                    //logout
                    break;
                case 400:
                    error.action = "retry";
                    error.message = 'Bad request/Validation error';
                    //logout
                    break;
                case 401:
                    error.action = "logout";
                    error.message = 'Unauthorized access';
                    //logout
                    break;
                case 402:
                    error.action = "retry";
                    error.message = 'Payment Required';
                    break;
                case 403:
                    error.action = "redirect";
                    error.message = 'Access is forbidden';
                    break;
                case 404:
                    error.action = "redirect";
                    error.message = 'Bad URI, or Missing Resource';
                    break;
                case 405:
                    error.action = "preventAction";
                    error.message = 'Method not allowed';
                    break;
                case 406:
                    error.action = "logout";
                    error.message = 'You must login to proceed';
                    //logout
                    break;
                case 407:
                    error.message = 'Proxy Authentication Required';
                    break;
                case 408:
                    error.action = "retry";
                    error.message = 'Request Timeout';
                    break;
                case 422:
                    error.action = "logout";
                    error.message = 'UNPROCESSABLE ENTITY';
                    break;
                case 500:
                    error.action = "SendErrorLog";
                    error.message = 'Internal Error 500';
                    break;
                default:
                    error.action = "SendErrorLog";
                    error.message = 'Unknow Error';
                    break;
            }
        }
        // console.log({ response: false, status: false, message: error.message, action: error.action })
        this.action.next({ ...error, ...err });
        return { response: false, status: false, message: error.message, action: error.action };
    }
    public get errorCodes(): number[] {
        let codes = [];
        for (let index = 400; index < 450; index++) {
            codes.push(index);
        }
        codes.push(500);
        codes.push(0);
        return codes;
    }
    private getHiddenStatus(message: string): number {
        let errorCode = 0;
        this.errorCodes.forEach(code => {
            if (message.includes(code.toString())) {
                errorCode = code;
            }
        });
        return errorCode;
    }

}
